import { render } from "./Acquisitions.vue?vue&type=template&id=6a13cea0&scoped=true"
import script from "./Acquisitions.vue?vue&type=script&lang=js"
export * from "./Acquisitions.vue?vue&type=script&lang=js"

import "./Acquisitions.vue?vue&type=style&index=0&id=6a13cea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a13cea0"]])

export default __exports__